import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/faqs', { params })
  },
  store (formData) {
    return apiClient.post('/faqs', formData)
  },
  show (id, params) {
    return apiClient.get(`/faqs/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/faqs/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/faqs/${id}`)
  }
}
